import knightsConstantRedux from "../constant";
const initialSettings = {
  departmentList: [],
};
const settings = (state = initialSettings, action, root) => {
  switch (action.type) {
    case knightsConstantRedux.SET_DEPARTMENT_ITEM:
      return {
        ...state,
        departmentList: [...state.departmentList, action.payload.department],
      };
    case knightsConstantRedux.SET_DEPARTMENT_LISTS:
      return {
        ...state,
        departmentList: action.payload.departmentList,
      };

    default:
      return state;
  }
};
export default settings;
